import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=0f56a808&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=0f56a808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56a808",
  null
  
)

export default component.exports